<template>
  <picture>
    <source
      v-if="isNewImage()"
      :srcset="
        webpImg(1) + ' 1x,' + webpImg(2) + ' 1.7x,' + webpImg(3) + ' 2.5x'
      "
      type="image/webp"
    />
    <img
      v-if="typeof imageInfo.onImageLoad === 'function'"
      :src="getThumbnailImg()"
      :alt="imageInfo.alt"
      :class="imageInfo.className"
      @load="imageInfo.onImageLoad"
      @error="imageDisplayNone($event)"
    />
    <img
      v-else
      :src="getThumbnailImg()"
      :alt="imageInfo.alt"
      :class="imageInfo.className"
      @error="imageDisplayNone($event)"
    />
  </picture>
</template>
<script>
  import { resizeThumbnail } from '@/common/utils/image'
  import {
    DEV_IMAGE_WAVVE_COM,
    DEV_IMG_CDN_WAVVE_COM,
    DEV_IMG_POOQ_CO_KR,
    DEV_IMG_WAVVW_COM,
    IMAGE_CDN_WAVVE_COM,
    IMAGE_WAVVE_COM,
    IMG_POOQ_CO_KR,
    IMG_WAVVW_COM,
    QA_IMAGE_WAVVE_COM,
    QA_IMG_CDN_WAVVE_COM,
    QA_IMG_POOQ_CO_KR,
    QA_IMG_WAVVW_COM,
  } from '@/common/resources/image.const'
  export default {
    name: 'WebpImage',
    props: {
      imageInfo: {
        type: Object,
      },
    },
    computed: {
      image() {
        return (this.imageInfo?.imageUrl ?? '')
          .replace('https://', '')
          .replace('http://', '')
      },
    },
    methods: {
      imageDisplayNone($event) {
        $event.target.style.display = 'none'
        if (typeof this.imageInfo?.onImageError === 'function') {
          return this.imageInfo.onImageError($event)
        }
      },
      isNewImage() {
        const imageDomainList = [
          IMG_WAVVW_COM,
          IMAGE_WAVVE_COM,
          IMAGE_CDN_WAVVE_COM,
          IMG_POOQ_CO_KR,
          DEV_IMG_WAVVW_COM,
          DEV_IMAGE_WAVVE_COM,
          DEV_IMG_CDN_WAVVE_COM,
          DEV_IMG_POOQ_CO_KR,
          QA_IMG_WAVVW_COM,
          QA_IMAGE_WAVVE_COM,
          QA_IMG_CDN_WAVVE_COM,
          QA_IMG_POOQ_CO_KR,
        ]
        return (
          imageDomainList.filter((domain) => this.image.startsWith(domain))
            .length > 0
        )
      },
      getThumbnailImg(ratio = 2) {
        if (this.isNewImage()) {
          return resizeThumbnail(this.image, {
            width: this.imageInfo.width,
            height: this.imageInfo.height,
            quality: this.imageInfo.quality || 80,
            ratio,
            option: this.imageInfo.option,
            envPrefix: this.imageInfo.envPrefix,
          })
        } else {
          return `https://${this.image}`
        }
      },
      addTimeStampToImage(image) {
        const timeStamp = new Date().getTime()
        return `${image}?timestamp=${timeStamp}`
      },
      webpImg(ratio) {
        if (!this.isNewImage()) return
        const resizeImageUrl = this.getThumbnailImg(ratio)
        const hasTimeStamp = resizeImageUrl.search(/timestamp=/gi) > -1
        const image = resizeImageUrl.split('.').slice(0, -1).join('.') + '.webp'
        return hasTimeStamp ? this.addTimeStampToImage(image) : image
      },
    },
  }
</script>
